import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, AuthErrorBoundary } from './auth';
import { ToastProvider } from './contexts/ToastContext';
import { TestModeProvider } from './contexts/TestModeContext';
import App from './App';

// Tailwind CSS + Hyperkit design tokens
import './styles/globals.css';

// Configure React Query client with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <TestModeProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </TestModeProvider>
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </AuthErrorBoundary>
  </React.StrictMode>
);
